import { ReactElement } from 'react';

import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { CmsApiSidebarContentBlock } from 'modules/cms/api/types/CmsApiSidebar';
import { mapCmsBlock } from 'modules/cms/mappers';

type Props = {
  content: CmsApiPage;
  block: CmsApiSidebarContentBlock;
  index: number;
};

export function CmsSidebarBlockComponent({
  content,
  block,
  index,
}: Props): ReactElement {
  const { component } = mapCmsBlock({
    content,
    isBody: false,
    block,
    index,
    anchor: undefined,
    isPageHeader: false,
    offsetAnchors: false,
    isSidebar: true,
  });

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{component}</>;
}
